<form style="display: flex; justify-content: center" [formGroup]="createBusinessForm">
    <div class="row w-100 my-3">
        <div class="row w-100">
            <div class="col-6">
                <a>Business Unit</a>
                <mat-form-field class="w-100">
                    <mat-select formControlName="businessUnit" placeholder="None">
                        @for (unit of businessUnits(); track unit) {
                            <mat-option [value]="unit" style="background-color: white">
                                {{ unit }}
                            </mat-option>
                        }
                    </mat-select>
                </mat-form-field>
            </div>

            <div class="col-6">
                <a>First Owner</a>
                <mat-form-field class="w-100">
                    <input matInput type="text" [value]="currentUser()?.displayName ?? ''" readonly />
                </mat-form-field>
            </div>
        </div>

        <div class="row w-100">
            <div class="col-6">
                <a>Platform</a><span class="ms-1" style="color: red">*</span>
                <mat-form-field class="w-100">
                    <mat-select formControlName="platform" placeholder="None">
                        @for (platformName of getPlatformNames(); track platformName) {
                            <mat-option [value]="platformName" style="background-color: white">
                                {{ platforms()[platformName].description }}
                            </mat-option>
                        }
                    </mat-select>
                    <mat-error *ngIf="hasFieldError('platform')"> Platform is required </mat-error>
                </mat-form-field>
            </div>

            <div class="col-6">
                <a>Second Owner</a><span class="ms-1" style="color: red">*</span>
                <app-user-graph-autocomplete controlName="secondOwner" />
                <mat-error *ngIf="hasFieldError('secondOwner')"> Second Owner is required </mat-error>
            </div>
        </div>

        <div class="row w-100">
            <div class="col-6">
                <a>Capability</a><span class="ms-1" style="color: red">*</span>
                <mat-form-field class="w-100">
                    <mat-select formControlName="capability" placeholder="None">
                        @for (capability of capabilities$ | async; track capability) {
                            <mat-option [value]="capability.name" style="background-color: white">
                                {{ capability.name }}
                            </mat-option>
                        }
                    </mat-select>
                    <mat-error *ngIf="hasFieldError('capability')"> Capability is required </mat-error>
                </mat-form-field>
            </div>

            <div class="col-6">
                <a>SubGroup</a>
                <mat-form-field class="w-100">
                    <input matInput type="text" formControlName="subGroup" />
                </mat-form-field>
            </div>
        </div>

        <div class="d-flex justify-content-end align-items-center gap-3">
            <button mat-raised-button type="button" (click)="resetForm()">Reset</button>
            <button mat-flat-button type="submit" (click)="onSubmit()">Create business domain</button>
        </div>
    </div>
</form>

<ng-template #provisioningModal let-modal>
    <div class="modal-header">
        <h4 class="modal-title w-100 text-center">
            {{ provisioningDone() ? 'Provisioning Complete' : 'Provisioning...' }}
        </h4>
    </div>
    <div class="modal-body text-center" style="white-space: pre-wrap; overflow-wrap: anywhere">
        @if (!provisioningDone()) {
            <div class="my-3">
                <div class="spinner-border text-primary" role="status">
                    <span class="visually-hidden">Loading...</span>
                </div>
            </div>
            <div>Provisioning your business domain, please wait...</div>
        } @else if (activeBusinessDomain()) {
            <div class="my-3" style="text-align: center">
                <h5>Business Domain Name</h5>
                <div>
                    {{ activeBusinessDomain()!.name }}
                </div>
                <hr />
                <h5>Data Lake Folder</h5>
                <div>
                    <a [href]="activeBusinessDomain()!.azureDataLakeUri" target="_blank" rel="noopener">
                        {{ activeBusinessDomain()!.azureDataLakeUri }}
                    </a>
                </div>
                <hr />
                <h5>Entra Groups</h5>
                <div>
                    Practitioners:
                    <a
                        [href]="
                            'https://portal.azure.com/#view/Microsoft_AAD_IAM/GroupDetailsMenuBlade/~/Overview/groupId/' +
                            activeBusinessDomain()!.roles.Practitioners.groupId +
                            '/menuId/'
                        "
                        target="_blank"
                        rel="noopener"
                    >
                        {{ activeBusinessDomain()!.roles.Practitioners.groupId }}
                    </a>
                    <br />
                    Remediators:
                    <a
                        [href]="
                            'https://portal.azure.com/#view/Microsoft_AAD_IAM/GroupDetailsMenuBlade/~/Overview/groupId/' +
                            activeBusinessDomain()!.roles.Remediators.groupId +
                            '/menuId/'
                        "
                        target="_blank"
                        rel="noopener"
                    >
                        {{ activeBusinessDomain()!.roles.Remediators.groupId }}
                    </a>
                </div>
                <hr />
                <h5>Collibra Roles</h5>
                <div>
                    Practitioners: {{ activeBusinessDomain()!.roles.Practitioners.collibraRoleName }}<br />
                    Remediators: {{ activeBusinessDomain()!.roles.Remediators.collibraRoleName }}
                </div>
            </div>
            <button class="btn btn-primary" (click)="modal.close()">Close</button>
        }
    </div>
</ng-template>

<ng-template #errorModal let-modal>
    <div class="modal-header">
        <h4 class="modal-title w-100 text-center">Error</h4>
    </div>
    <div class="modal-body text-center">
        <div>{{ errorMessage() }}</div>
        <button class="btn btn-primary mt-3" (click)="modal.close()">Close</button>
    </div>
</ng-template>
